export function formatDate(iso, opts) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-US", opts || { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
}

export function relativeTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return formatDate(iso);
}

export const PRIORITY = {
  critical: { label: "Critical", text: "text-st-critical", bg: "bg-st-critical/10", border: "border-st-critical", dot: "bg-st-critical" },
  high: { label: "High", text: "text-st-warning", bg: "bg-st-warning/10", border: "border-st-warning", dot: "bg-st-warning" },
  medium: { label: "Medium", text: "text-st-info", bg: "bg-st-info/10", border: "border-st-info", dot: "bg-st-info" },
  low: { label: "Low", text: "text-ink-muted", bg: "bg-surface-muted", border: "border-border", dot: "bg-ink-faint" },
};

export const STATUS = {
  new: { label: "New", cls: "bg-surface-muted text-ink-muted" },
  processing: { label: "Processing", cls: "bg-st-info/10 text-st-info" },
  processed: { label: "Processed", cls: "bg-st-success/10 text-st-success" },
  in_progress: { label: "In Progress", cls: "bg-st-info/10 text-st-info" },
  awaiting_approval: { label: "Awaiting Approval", cls: "bg-st-warning/15 text-st-warning" },
  revision_requested: { label: "Revision", cls: "bg-st-warning/15 text-st-warning" },
  internal_complete: { label: "Internal Complete", cls: "bg-st-success/10 text-st-success" },
  delivered: { label: "Delivered", cls: "bg-st-success/15 text-st-success" },
  rejected: { label: "Rejected", cls: "bg-st-critical/10 text-st-critical" },
  pending: { label: "Pending", cls: "bg-st-warning/15 text-st-warning" },
  approved: { label: "Approved", cls: "bg-st-success/15 text-st-success" },
  active: { label: "Active", cls: "bg-st-success/10 text-st-success" },
  done: { label: "Done", cls: "bg-st-success/10 text-st-success" },
  completed: { label: "Completed", cls: "bg-st-success/10 text-st-success" },
};
